import styled from "styled-components";

export const LeftWrapper = styled.div`
  z-index: 99;
  background-color: white;
  position: fixed;
  display: flex;
  height: 100%;
  box-shadow: #ccc 1px 1px 10px;
  font-size: 12px;

  .cmps {
    width: 80px;
  }
  .cmp {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;

    span {
      margin-top: 4px;
    }

    &.selected {
      box-sizing: border-box;
      border-left: solid 3.5px #0057ff;
      color: #0057ff;
    }

    &:hover {
      color: #0057ff;
    }
  }
  .cmpIcon {
    font-size: 20px;
    color: #181819;
  }
  // 文字
  .cmpText {
    font-size: 14px;
    color: #666;
  }
`;
